import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const CookiesPage: React.FC = () => {
  const { t } = useLanguage();
  
  return (
    <div className="pt-24 pb-16">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl font-bold mb-6">Cookie Policy</h1>
          
          <div className="prose prose-lg prose-invert">
            <p className="text-gray-300 mb-6">Last Updated: October 15, 2025</p>
            
            <section className="mb-8">
              <h2 className="text-xl font-bold mb-4">1. Introduction</h2>
              <p className="text-gray-300 mb-4">
                This Cookie Policy explains how TattooNailGenius ("we", "us", or "our") handles cookies on our website. Unlike many websites, TattooNailGenius does not use cookies to track or store information about your browsing behavior.
              </p>
            </section>
            
            <section className="mb-8">
              <h2 className="text-xl font-bold mb-4">2. What Are Cookies</h2>
              <p className="text-gray-300 mb-4">
                Cookies are small text files that are stored on your device (computer, tablet, or mobile) when you visit a website. Cookies are widely used to make websites work more efficiently and provide information to the owners of the site.
              </p>
            </section>
            
            <section className="mb-8">
              <h2 className="text-xl font-bold mb-4">3. Our Cookie Policy</h2>
              <p className="text-gray-300 mb-4">
                TattooNailGenius does not use cookies for tracking purposes. We prioritize your privacy and aim to provide our services without the need to collect unnecessary information about your browsing behavior.
              </p>
              <p className="text-gray-300 mb-4">
                The only data we store locally on your device is:
              </p>
              <ul className="list-disc pl-6 mb-4 text-gray-300">
                <li>Your language preference (stored in localStorage)</li>
                <li>Authentication tokens (if you create an account)</li>
              </ul>
              <p className="text-gray-300">
                This minimal data storage is essential for providing our service and maintaining your session if you log in.
              </p>
            </section>
            
            <section className="mb-8">
              <h2 className="text-xl font-bold mb-4">4. Third-Party Services</h2>
              <p className="text-gray-300 mb-4">
                Our website may include content from third-party services, such as:
              </p>
              <ul className="list-disc pl-6 mb-4 text-gray-300">
                <li>Supabase (for authentication and database services)</li>
                <li>Replicate (for AI image generation)</li>
              </ul>
              <p className="text-gray-300">
                These third-party services may use their own cookies or tracking technologies. We recommend reviewing the privacy and cookie policies of these services for more information about their practices.
              </p>
            </section>
            
            <section className="mb-8">
              <h2 className="text-xl font-bold mb-4">5. Managing Cookies in Your Browser</h2>
              <p className="text-gray-300 mb-4">
                Although we do not use tracking cookies, you always have the option to control cookies through your browser settings. Most web browsers allow some control of most cookies through browser settings.
              </p>
              <p className="text-gray-300 mb-4">
                To find out more about cookies, including how to see what cookies have been set and how to manage and delete them, visit <a href="https://www.allaboutcookies.org" className="text-purple-400 hover:text-purple-300" target="_blank" rel="noopener noreferrer">www.allaboutcookies.org</a>.
              </p>
            </section>
            
            <section className="mb-8">
              <h2 className="text-xl font-bold mb-4">6. Necessary Local Storage</h2>
              <p className="text-gray-300 mb-4">
                While we don't use cookies, we do use browser local storage to remember your language preference. This data stays on your device and is not sent to our servers.
              </p>
              <p className="text-gray-300">
                If you're logged in, we also store authentication tokens which are necessary to maintain your session. These tokens are managed securely through our authentication service.
              </p>
            </section>
            
            <section className="mb-8">
              <h2 className="text-xl font-bold mb-4">7. Changes to This Cookie Policy</h2>
              <p className="text-gray-300 mb-4">
                We may update our Cookie Policy from time to time. We will notify you of any changes by posting the new Cookie Policy on this page and updating the "Last Updated" date at the top.
              </p>
              <p className="text-gray-300">
                You are advised to review this Cookie Policy periodically for any changes. Changes to this Cookie Policy are effective when they are posted on this page.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl font-bold mb-4">8. Contact Us</h2>
              <p className="text-gray-300">
                If you have any questions about our Cookie Policy, please contact us at privacy@tattoonailgenius.com.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookiesPage;